
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldPassword from './form-field-password'
import FormPasswordStrengthMeter from './form-password-strength-meter'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldpassword"
    }}>{`FormFieldPassword`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "password-field"
    }}>{`Password field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a password value. Browsers obscure the password; the strength meter and show or hide functionality are custom.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldPassword\n      {...state}\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => {\n        setState({ value: e.target.value })\n      }}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldPassword,
      FormPasswordStrengthMeter
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldPassword {...state} labelText="Label" maxLength={30} onChange={e => {
          setState({
            value: e.target.value
          });
        }} mdxType="FormFieldPassword" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldPassword\n      {...state}\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      maxLength={30}\n      meterValue={state.value.length}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldPassword,
      FormPasswordStrengthMeter
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldPassword {...state} labelText="Label" labelTag="Tag" maxLength={30} meterValue={state.value.length} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldPassword" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldPassword\n      {...state}\n      disabled\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      maxLength={30}\n      meterValue={state.value.length}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldPassword,
      FormPasswordStrengthMeter
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldPassword {...state} disabled labelText="Label" labelTag="Tag" maxLength={30} meterValue={state.value.length} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldPassword" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldPassword\n      {...state}\n      labelText=\"Label\"\n      maxLength={30}\n      meterValue={state.value.length}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldPassword,
      FormPasswordStrengthMeter
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldPassword {...state} labelText="Label" maxLength={30} meterValue={state.value.length} onChange={e => setState({
          value: e.target.value
        })} placeholder="Text placeholder" mdxType="FormFieldPassword" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "password-field-slim"
    }}>{`Password field (slim)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For a password value. Browsers obscure the password; the strength meter and show or hide
functionality are custom. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={6} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldPassword\n      {...state}\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldPassword,
      FormPasswordStrengthMeter
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldPassword {...state} labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldPassword" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "-password-field-properties"
    }}>{`## Password field properties`}</h2>
    <Props of={FormFieldPassword} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;